module.exports = __webpack_public_path__ + "img/times-circle-white.0878f00d.svg";